/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */

import { createSelector } from 'reselect';

export const getPerformanceFilter = (state) => state.performanceFilter;

const getCommentary = (state) => state.commentary;

const getCommentaryType = (state, type) => type;

export const isCommentaryLoaded = createSelector(
  getCommentary,
  getCommentaryType,
  (commentary, type) =>
    commentary[type] && commentary[type].allPossibleLookupIndices
);

export const getActivitySummaryCommentary = createSelector(
  getCommentary,
  (commentary) => commentary.activitySummary || {}
);
